function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1{stroke-miterlimit:8;stroke-width:3px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, React.createElement("ellipse", {
  className: "cls-1",
  cx: 84.59,
  cy: 152.9,
  rx: 17.75,
  ry: 18.21
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 30.59,
  cy: 170.9,
  rx: 17.75,
  ry: 18.21
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 15.9,
  cy: 43.6,
  rx: 14.4,
  ry: 14.78
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 69.9,
  cy: 81.6,
  rx: 14.4,
  ry: 14.78
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 70.03,
  cy: 30.7,
  rx: 9.73,
  ry: 9.99
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 32.03,
  cy: 73.7,
  rx: 9.73,
  ry: 9.99
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 148.03,
  cy: 92.7,
  rx: 9.73,
  ry: 9.99
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 22.97,
  cy: 110.88,
  rx: 17.75,
  ry: 18.21,
  transform: "translate(-85.74 79.21) rotate(-62.05)"
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 131.73,
  cy: 57.99,
  rx: 14.4,
  ry: 14.78,
  transform: "translate(18.77 147.18) rotate(-62.05)"
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 107.73,
  cy: 20.99,
  rx: 14.4,
  ry: 14.78,
  transform: "translate(38.71 106.32) rotate(-62.05)"
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 160.73,
  cy: 15.99,
  rx: 14.4,
  ry: 14.78,
  transform: "translate(71.29 150.48) rotate(-62.05)"
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 137.75,
  cy: 155.28,
  rx: 9.73,
  ry: 9.99,
  transform: "translate(-63.98 204.2) rotate(-62.05)"
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 122.75,
  cy: 109.28,
  rx: 9.73,
  ry: 9.99,
  transform: "translate(-31.32 166.5) rotate(-62.05)"
})));

var SvgCellfinateDensidadAlta = function SvgCellfinateDensidadAlta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 176.93 190.61",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCellfinateDensidadAlta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cellfinate_densidad_alta.0d6261b8.svg";
export { ForwardRef as ReactComponent };